import React, { useState, useEffect } from "react"

import { Form } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
import { getGAUserID } from "./util"
import { getUser } from "@starberry/myaccount-website-utils";

import axios from "axios"
import * as qs from "query-string"

const formatPrice = price => {
  if (!price)
      return '';
  return new Intl.NumberFormat("en", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
  }).format(price)
}


function MySimpleForm(props) {

  console.log("data 111", props)

  const userData = getUser();
  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  let fields = ([
    {
      element: "config",
      formname: "Make an Offer",
      form_type: "make-an-offer",
      error_text: "Highlighted fields are required",
      success_text: "Thank you for your offer. A member of our team will contact you shortly.",
      email_temp_user: "make_an_offer_user",
      email_temp_admin: "make_an_offer_admin",
      email_server_func: "makeanoffer",
      event_tracking: "make an offer",
      page_url: "/make-an-offer"
    },
    {
      grpmd: "12",
      label: "Name",
      placeholder: "Your Name",
      name: "name",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[a-zA-Z0-9()]+(\\s+[a-zA-Z0-9()]+)*$",
      labelClass: "content_b-18",
      defaultValue: userData?.name || ``
    },
    {
      grpmd: "12",
      label: "Email",
      placeholder: "Email Address",
      name: "email",
      type: "email",
      element: "input",
      required: true,
      patternchk: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      labelClass: "content_b-18",
      defaultValue: userData?.email || ``

    },
    {
      grpmd: "12",
      label: "Telephone",
      placeholder: "Telephone Number",
      name: "telephone",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
      labelClass: "content_b-18",
      defaultValue: userData?.mobile || ``

    },
    {
      grpmd: "12",
      label: "Offer Amount (£)",
      placeholder: "Offer Amount",
      name: "amount",
      type: "number",
      element: "input",
      required: true,
      patternchk: "",
      class: "mb-4"
    },
    {
      grpmd: "12",
      label: "Rent Frequency",
      placeholder: "Rent Frequency",
      name: "rent_frequency",
      type: "select",
      element: "select",
      required: true,
      patternchk: "",
      class: "mb-4",
      values: [
          'Weekly',
          'Monthly',
          'Annually'
      ]
    },

    {
      grpmd: "12",
      label: "Message",
      placeholder: "Write your message here...",
      name: "message",
      element: "textarea",
      class: "mb-4",
      rows: "1",
      labelClass: "content_b-18"
    },
    {
      grpmd: "12",
      name: "Send message",
      type: "submit",
      element: "button",
      value: "submit",
      class: "btn btn-success",
      labelClass: "content_b-18"
    },
    {
      text: 'By clicking Send message, you agree to our <a href="/terms-and-conditions/">Terms & Conditions</a> and <a href="/privacy-policy/">Privacy Policy</a>',
      element: "html",
      class: "form-text"
    },
    {
      element: "captcha",
      class: "py-2",
      captchaRef: recaptchaRef
    },
  ]);

  if (props.data?.search_type !== 'lettings') {
    fields = fields.filter((x) => x.name !== 'rent_frequency')
}


  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }

  useEffect(() => {
    if (token !== '') {

      const processFromData = async () => {

        let formData = new FormData();

        formData.append('data', JSON.stringify(formvalues));

        postFormData(formData).then(apiRes => {

          if (formvalues?.amount) {
            formvalues.amount = `${formatPrice(formvalues.amount)}`
            if (formvalues?.rent_frequency)
              formvalues.amount = formvalues.amount + ` ${formvalues?.rent_frequency}`
          }

          // lets send mail
          const axiosOptions_email = {
            url: '/.netlify/functions/server/' + fields[0].email_server_func,
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: qs.stringify(formvalues),
          }

          axios(axiosOptions_email)
            .then(response => {
            })
            .catch(err => {

            }
            );
        });

        formvalues['g-recaptcha-response'] = token;

        const url = typeof window !== 'undefined' ? window.location.href : ''
        if (url.indexOf("property") > -1 && fields[4].event_tracking_decider) {
          fields[0].formname = 'Get mortgage help';
        }
        // tracking event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': props.person_contact ? 'form-person-contact' : props.formname ? 'Get in touch' : 'form-' + fields[0].event_tracking,
          'formId': 'form-' + fields[0].event_tracking,
          'formName': fields[0].formname,
          'formLabel': fields[0].formname
        });

        setShowerror(false);
        setThankyou(true);
        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
    else {

      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))

      json['ga_client_id'] = getGAUserID();
      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      const data = JSON.parse(sessionStorage.getItem('data'))
      const url = sessionStorage.getItem('property_url')
      json['display_address'] = data?.display_address;
      json['url'] = url;

      setFormvalues(json);

      recaptchaRef.current.execute();

      setValidated(false);

      const form = event.target
      form.reset();

    }
  };

  return (
    <div className="form stbform">
      {showerror && <div className="alert-error">
        <p>{fields[0].error_text}</p>
      </div>} 

      {showthankyou && <div className="alert-success">
        <p>{fields[0].success_text}</p>
      </div>}


      <Form className="contact-form" name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit}>
        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="to_email_id" value={props.to_email_id} />
        <input type="hidden" name="property_type" value={props?.data?.search_type} />
        <input type="hidden" name="property_id" value={props?.data?.crm_id} />
        <input type="hidden" name="negotiator_id" value={props?.data?.crm_negotiator_id?.ID} />
        <input type="hidden" name="bot-field" />
        {fields.map((field, index) => {
          if ("input" === field.element) {
            return (
              <InputField
                name={field.name}
                grpmd={field.grpmd}
                ref={field.ref}
                type={field.type}
                fieldClass={field.class}
                placeholder={field.placeholder}
                labelClass={field.labelClass}
                required={field.required}
                key={`${field.element}~${index}`}
                pattern={field.patternchk}
                handlechange={handlechange}
                defaultValue={field.defaultValue}
              />
            );
          }
          if ("select" === field.element) {
            return (
              <SelectField
                name={field.name}
                grpmd={field.grpmd}
                ref={field.ref}
                required={field.required}
                fieldClass={field.class}
                placeholder={field.placeholder}
                values={field.values}
                key={`${field.element}~${index}`}
                handlechange={handlechange}
                componentprops={props}
              />
            );
          }
          if ("textarea" === field.element) {
            return (
              <TextAreaField
                name={field.name}
                grpmd={field.grpmd}
                ref={field.ref}
                rows={field.rows}
                fieldClass={field.class}
                labelClass={field.labelClass}
                placeholder={field.placeholder}
                required={field.required}
                key={`${field.element}~${index}`}
                handlechange={handlechange}
              />
            );
          }
          if ("checkbox" === field.element) {
            return (
              <CheckboxField
                name={field.name}
                ref={field.ref}
                value={field.value}
                fieldClass={field.class}
                placeholder={field.placeholder}
                required={field.required}
                key={`${field.name}~${index}`}
                handlechange={handlechange}
              />
            );
          }
          if ("radio" === field.element) {
            return (
              <RadioField
                name={field.name}
                ref={field.ref}
                value={field.value}
                fieldClass={field.class}
                checked={field.checked}
                placeholder={field.placeholder}
                required={field.required}
                key={`${field.name}~${index}`}
                handlechange={handlechange}
                lastchild={field.lastchild}
              />
            );
          }
          if ("html" === field.element) {
            return (
              <HtmlBox
                text={field.text}
                fieldClass={field.class}
                key={`${field.element}~${index}`}
              />
            );
          }
          if ("captcha" === field.element) {
            return (
              <ReCaptchaBox
                fieldClass={field.class}
                captRef={field.captchaRef}
                key={`${field.element}~${index}`}
                handleonVerify={handleonVerify}
              />
            );
          }
          if ("button" === field.element) {
            return (
              <ButtonField
                name={field.name}
                fieldClass={field.class}
                type={field.type}
                value={field.value}
                key={`${field.element}~${index}`}
              />
            );
          }
        })
        }
        <div ref={myRef} />

      </Form>
    </div>
  );
}


const MySimpleFormPage = (props) => (
  <MySimpleForm {...props} />
)

export default MySimpleFormPage